import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import HtmlParser from 'react-html-parser';

import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';

import {
    responseGet, globalSettings, setBadgeStatusGeneric, styles, validateDecimals, dateTimeFormatGlobalSet, sendMessageCloseCurrentWindowAsync, numberSet,
    separatorsNumbersSet, buttonProcessGet, languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings'
import axios from 'axios';
import { receiptModelGet } from '../../models/receipts/receipt';
import { apartmentReceiptPaymentModelGet } from '../../models/payments/apartmentReceiptPayment';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { bankModelGet } from '../../models/banks/bank';
import { bankAccountModelGet } from '../../models/bankAccounts/bankAccount';
import { paymentMethodModelGet } from '../../models/paymentMethods/paymentMethod';
import { GlobalFormats } from '../../classes/main/globalFormats';

const neutralValue = 0.00;
const currentMethod = 'PaymentApartmentAddEditDetails';

export default function PaymentApartmentAddEditDetails({
    $ = {},
    auth = {},
    buildingBalance = neutralValue,
    setBuildingBalance = () => { },
    buildingBalanceSetAsync = async ({ balance = neutralValue, subMethod = '', }) => { },
    receipt = receiptModelGet({}),
    dtReceiptsId = '',
    dtReceiptsRowIndex = 0,
    payment = apartmentReceiptPaymentModelGet({}),
    setPayment = () => { },
    totalPayments = neutralValue,
    setTotalPayments = () => { },
    dtPaymentsId = '',
    dtPaymentsRowIndex = 0,
    apartment = apartmentModelGet({}),
    apartmentBalance = neutralValue,
    setApartmentBalance = () => { },
    apartmentReceipt = apartmentReceiptModelGet({}),
    setApartmentReceipt = () => { },
    dtApartmentsId = '',
    dtApartmentsRowIndex = 0,
    banks = [bankModelGet({})],
    banksDestiny = [bankModelGet({})],
    bankAccounts = [bankAccountModelGet({})],
    paymentMethods = [paymentMethodModelGet({})],
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    setProcessType = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let dtRowObj = {};
    let headerObj = {};
    const paymentDateId = 'paymentDate';
    const chkReconcileId = 'chkReconcile';
    const { html, tempusDominus } = globalSettings?.react;
    const { app, messages, icons, labels, } = globalSettings;
    const { properties: dbProps, } = globalSettings?.collections;
    const [bankAccountsByBank, setBankAccountsByBank] = useState([]);
    const [showBanks, setShowBanks] = useState(false);
    const [paymentMethodError, setPaymentMethodError] = useState('');
    const [bankError, setBankError] = useState('');
    const [bankDestinyError, setBankDestinyError] = useState('');
    const [bankAccountDestinyError, setBankAccountDestinyError] = useState('');
    const [dateError, setDateError] = useState('');
    const [referenceError, setReferenceError] = useState('');
    const [amountError, setAmountError] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnPaymentApartmentModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnPaymentApartmentModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnPaymentApartmentModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        inputs: {
            date: {
                id: 'inputPaymentApartmentModalDate',
                //className: 'form-control text-black bg-transparent datetimepicker-input',
                className: 'form-control datetimepicker-input',
            },
            reference: {
                id: 'inputPaymentApartmentModalReference',
                //className: 'form-control bg-transparent text-black',
                className: 'form-control',
            },
            amount: {
                id: 'inputPaymentApartmentModalAmount',
                //className: 'form-control text-black bg-transparent text-right',
                className: 'form-control text-right',
            },
        },
        dataTables: {
            // apartments: {
            //     buttons: {
            //         // create: {
            //         //     className: 'btn btn-outline-success float-right btn-sm',
            //         //     id: 'btnDtExpenseConceptsCreate',
            //         // },
            //     },
            //     icons: {
            //         // create: {
            //         //     id: 'iconDtExpenseConceptsCreate',
            //         //     className: icons?.plusCircle,
            //         // },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtApartmentsId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtApartmentsId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         // create: {
            //         //     id: 'spDtExpenseConceptsCreate',
            //         //     className: '',
            //         // },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoPaymentApartmentModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoPaymentApartmentModalBack',
                className: icons?.arrowAltCircleLeft,
            },
            close: {
                id: 'icoPaymentApartmentModalClose',
                className: icons?.listOl,
            },
        },
        selects: {
            paymentMethod: {
                id: 'selPaymentApartmentModalPaymentMethod',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
            bankOrigin: {
                id: 'selPaymentApartmentModalBankOrigin',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
            bankDestiny: {
                id: 'selPaymentApartmentModalBankDestiny',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
            bankAccount: {
                id: 'selPaymentApartmentModalBankAccount',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spPaymentApartmentModalSave',
                className: '',
            },
            back: {
                id: 'spPaymentApartmentModalBack',
                className: '',
            },
            close: {
                id: 'spPaymentApartmentModalClose',
                className: '',
            },
        },
    };
    //#endregion others

    //#region methods (payment)
    const paymentAddAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'paymentAddAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let apartmentReceiptLocal = {};
            let totalPaymentsLocal = neutralValue;
            let paymentMethodDescriptionLocal = [];
            let buildingBalanceLocal = neutralValue;
            let apartmentBalanceLocal = neutralValue;
            let buildingBalanceTotalLocal = neutralValue;
            let apartmentReceiptPaymentLocal = apartmentReceiptPaymentModelGet({});
            //#endregion variables

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            if (processType === 0) {
                //#region intitialize
                response = await dataSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }

                response = await validateFormDataAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }
                //#endregion intitialize

                controlsStatusSet({ processType: 1, subMethod: currentMethod, });

                //#region apartmentReceiptPayment create
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                dataObj = {
                    apartmentReceiptPayment: payment,
                    languageCode: languageObj?.code,
                    languageId: languageObj?.id,
                    url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data || {};

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                apartmentReceiptPaymentLocal = response?.result?.apartmentReceiptPayment || {};
                apartmentReceiptLocal = response?.result?.apartmentReceipt || {};
                setPayment(apartmentReceiptPaymentLocal);
                setApartmentReceipt(apartmentReceiptLocal);

                totalPaymentsLocal = numberSet({
                    number: (totalPayments + apartmentReceiptPaymentLocal?.amount),
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                setTotalPayments(totalPaymentsLocal);
                //#endregion apartmentReceiptPayment create

                //#region update receipts (dtReceipts)
                //#region variables
                dtRowObj = {
                    receiptNumberApartment: apartmentReceipt?.receiptNumberApartment,
                    from: dateTimeFormatGlobalSet({
                        date: receipt?.from,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    total: separatorsNumbersSet({
                        number: apartmentReceipt?.total,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    status: setBadgeStatusGeneric({
                        type: (apartmentReceiptLocal?.balance > neutralValue ? 1 : 0),
                        value: separatorsNumbersSet({
                            number: apartmentReceiptLocal?.balance,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        subMethod: currentMethod,
                    }),
                };
                //#endregion variables

                //#region methods
                $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                    //#region old code
                    // apartmentReceipt.receiptNumberApartment,
                    // dateTimeFormatGlobalSet(receipt.from, tempusDominus?.format?.date?.dmy, 0).result,
                    // separatorsNumbersSet(apartmentReceipt.total).result,
                    // setBadgeStatusGeneric((apartmentReceiptLocal.balance > neutralValue ? 1 : 0), separatorsNumbersSet(apartmentReceiptLocal.balance).result),
                    //#endregion old code
                    dtRowObj?.receiptNumberApartment,
                    dtRowObj?.from,
                    dtRowObj?.total,
                    dtRowObj?.status,
                    buttonProcessGet({
                        id: apartmentReceipt?.id,
                        description: apartment?.identifier,
                        showDetails: true,
                        labelDetails: labels?.receiptDetail?.[languageObj?.id],
                        enabledDetails: true,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        showDelete: false,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: false,
                        processButtons: [],
                        subMethod: currentMethod,
                    })?.result,
                ])?.draw(true);

                apartmentBalanceLocal = numberSet({
                    number: (apartmentBalance - apartmentReceiptPaymentLocal?.amount),
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                setApartmentBalance(apartmentBalanceLocal);
                //#endregion methods
                //#endregion update receipts (dtReceipts)

                //#region update apartments (dtApartmets)
                //#region variables
                dtRowObj = {
                    floor: apartment?.floor,
                    identifier: apartment?.identifier,
                    balance: separatorsNumbersSet({
                        number: apartmentBalanceLocal,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                };
                //#endregion variables

                //#region methods
                $(`#${dtApartmentsId}`)?.DataTable()?.row(dtApartmentsRowIndex)?.data?.([
                    //#region old code
                    // apartment.floor,
                    // apartment.identifier,
                    // separatorsNumbersSet(apartmentBalanceLocal).result,
                    //#endregion old code
                    dtRowObj?.floor,
                    dtRowObj?.identifier,
                    dtRowObj?.balance,
                    buttonProcessGet({
                        id: apartment?.id,
                        description: apartment?.identifier,
                        showDetails: true,
                        labelDetails: labels?.viewReceipts?.[languageObj?.id],
                        enabledDetails: true,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        showDelete: false,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: false,
                        processButtons: [],
                        subMethod: currentMethod,
                    }).result,
                ])?.draw(true);
                //#endregion methods
                //#endregion update apartments (dtApartmets)

                //#region paymentMethodDescription get
                paymentMethodDescriptionLocal = paymentMethods?.find(({ id }) => id === payment?.paymentMethodId)?.description || '';
                //#endregion paymentMethodDescription get

                //#region add data dtPayments
                //#region old code
                // processButtonsLocal = [{
                //     isVisible: true,
                //     isEnabled: true,
                //     showDivider: true,
                //     methodName: app?.backend?.methods?.attachedFiles,
                //     icon: icons?.paperClip,
                //     label: labels?.paymentSupportsAbbreviation?.[languageObj?.id],
                // }];
                //#endregion old code
                //#region variables
                dtRowObj = {
                    dateTime: dateTimeFormatGlobalSet({
                        date: apartmentReceiptPaymentLocal?.date,
                        type: tempusDominus?.format?.date?.ymdTwo,
                        format: 24,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    description: `<i class='${icons?.fasFa?.tag} text-primary'></i>${globalSettings?.html?.space?.formatOne}${paymentMethodDescriptionLocal}`,
                    date: dateTimeFormatGlobalSet({
                        date: apartmentReceiptPaymentLocal?.date,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    amount: separatorsNumbersSet({
                        number: apartmentReceiptPaymentLocal?.amount,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    processButtons: [{
                        isVisible: true,
                        isEnabled: true,
                        showDivider: true,
                        methodName: app?.backend?.methods?.attachedFiles,
                        icon: icons?.paperClip,
                        label: labels?.paymentSupportsAbbreviation?.[languageObj?.id],
                    }],
                };
                //#endregion variables

                //#region methods
                $(`#${dtPaymentsId}`)?.DataTable()?.row?.add([
                    //#region old code
                    // dateTimeFormatGlobalSet(apartmentReceiptPaymentLocal.date, tempusDominus?.format?.date?.ymdTwo, 24, false).result,
                    // `<i class='fas fa-tag text-primary'></i>${globalSettings?.html?.space?.formatOne}${paymentMethodDescriptionLocal}`,
                    // dateTimeFormatGlobalSet(apartmentReceiptPaymentLocal.date, tempusDominus?.format?.date?.dmy, 0).result,
                    // separatorsNumbersSet(apartmentReceiptPaymentLocal.amount).result,
                    //#endregion old code
                    dtRowObj?.dateTime,
                    dtRowObj?.description,
                    dtRowObj?.date,
                    dtRowObj?.amount,
                    buttonProcessGet({
                        id: apartmentReceiptPaymentLocal?.id,
                        description: apartmentReceiptPaymentLocal?.reference,
                        showDetails: true,
                        labelDetails: labels?.detail?.[languageObj?.id],
                        enabledDetails: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: (apartmentReceiptPaymentLocal?.concilationStatus !== 'C'),
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: (apartmentReceiptPaymentLocal?.concilationStatus !== 'C'),
                        processButtons: dtRowObj?.processButtons,
                    }).result,
                ])?.draw(true);
                //#endregion methods
                //#endregion add data dtPayments

                //#region update building balance
                buildingBalanceLocal = numberSet({
                    number: buildingBalance,
                    withDecimals: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                buildingBalanceTotalLocal = numberSet({
                    number: (buildingBalanceLocal - apartmentReceiptPaymentLocal?.amount),
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                setBuildingBalance(buildingBalanceTotalLocal);

                response = await buildingBalanceSetAsync({
                    balance: buildingBalanceTotalLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }
                //#endregion update building balance

                await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

                await sendMessageCloseCurrentWindowAsync({
                    msgType: 0,
                    msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const paymentEditAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'paymentEditAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let concilationStatusTwoLocal = '';
            let paymentTotalsLocal = neutralValue;
            let paymentMethodDescriptionLocal = '';
            let buildingBalanceLocal = neutralValue;
            let apartmentBalanceLocal = neutralValue;
            let buildingBalanceTotalLocal = neutralValue;
            let apartmentReceiptLocal = apartmentReceiptModelGet({});
            let apartmentReceiptPaymentLocal = apartmentReceiptPaymentModelGet({});
            let apartmentReceiptPaymentBeforeLocal = apartmentReceiptPaymentModelGet({});
            //#endregion variables

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await dataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await validateFormDataAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region apartmentReceiptPayment update
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartmentReceiptPayment: payment,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                url: `${app?.backend?.url}${app?.backend?.urlApiV1}${app?.backend?.urlApartmentReceiptPayments}/${payment?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            apartmentReceiptPaymentLocal = response?.result?.apartmentReceiptPayment || {};
            apartmentReceiptPaymentBeforeLocal = response?.result?.apartmentReceiptPaymentBefore || {};
            apartmentReceiptLocal = response.result.apartmentReceipt;
            setPayment(apartmentReceiptPaymentLocal);
            setApartmentReceipt(apartmentReceiptLocal);

            paymentTotalsLocal = numberSet({
                number: ((totalPayments - apartmentReceiptPaymentBeforeLocal?.amount) + apartmentReceiptPaymentLocal?.amount),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            setTotalPayments(paymentTotalsLocal);
            //#endregion apartmentReceiptPayment update

            //#region update payments (dtPayments)
            //#region payment type get
            paymentMethodDescriptionLocal = paymentMethods?.find(({ id }) => id === apartmentReceiptPaymentLocal?.paymentMethodId)?.description || '';
            concilationStatusTwoLocal = isUndNullEmp({ data: apartmentReceiptPaymentLocal?.concilationStatus, subMethod: currentMethod, })?.result ?
                `<i class='${icons?.fasFa?.tag} text-primary'></i>` :
                `<i class='${icons?.fasFa?.tag} text-warning'></i>`;
            //#endregion payment type get

            //#region variables
            dtRowObj = {
                dateTime: dateTimeFormatGlobalSet({
                    date: apartmentReceiptPaymentLocal?.date,
                    type: tempusDominus?.format?.date?.ymdTwo,
                    format: 24,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                paymentDescription: `${concilationStatusTwoLocal}${globalSettings?.html?.space?.formatOne}${paymentMethodDescriptionLocal}`,
                date: dateTimeFormatGlobalSet({
                    date: apartmentReceiptPaymentLocal?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                amount: separatorsNumbersSet({
                    number: apartmentReceiptPaymentLocal?.amount,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                processButtons: [{
                    isVisible: true,
                    isEnabled: true,
                    showDivider: true,
                    methodName: app?.backend?.methods?.attachedFiles,
                    icon: icons?.paperClip,
                    label: labels?.paymentSupportsAbbreviation?.[languageObj?.id],
                }],
            };
            //#endregion variables

            //#region methods
            $(`#${dtPaymentsId}`)?.DataTable()?.row(dtPaymentsRowIndex)?.data?.([
                //#region old code
                // dateTimeFormatGlobalSet(apartmentReceiptPaymentLocal.date, tempusDominus?.format?.date?.ymdTwo, 24, false).result,
                // `${concilationStatusTwoLocal}${globalSettings?.html?.space?.formatOne}${paymentMethodDescriptionLocal}`,
                // dateTimeFormatGlobalSet(apartmentReceiptPaymentLocal.date, tempusDominus?.format?.date?.dmy, 0, false).result,
                // separatorsNumbersSet(apartmentReceiptPaymentLocal.amount).result,
                //#endregion old code
                dtRowObj?.dateTime,
                dtRowObj?.paymentDescription,
                dtRowObj?.date,
                dtRowObj?.amount,
                buttonProcessGet({
                    id: apartmentReceiptPaymentLocal?.id,
                    description: apartmentReceiptPaymentLocal?.reference,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: (apartmentReceiptPaymentLocal?.concilationStatus !== 'C'),
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: (apartmentReceiptPaymentLocal?.concilationStatus !== 'C'),
                    processButtons: dtRowObj?.processButtons,
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods
            //#endregion update payments (dtPayments)

            //#region update receipts (dtReceipts)
            //#region variables
            dtRowObj = {
                receiptNumberApartment: apartmentReceiptLocal?.receiptNumberApartment,
                from: dateTimeFormatGlobalSet({
                    date: receipt?.from,
                    type: languageObj?.format?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                total: separatorsNumbersSet({
                    number: apartmentReceiptLocal?.total,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
                status: setBadgeStatusGeneric({
                    type: (apartmentReceiptLocal?.balance > neutralValue ? 1 : 0),
                    value: separatorsNumbersSet({
                        number: apartmentReceiptLocal?.balance,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    subMethod: currentMethod,
                }),
            };
            //#endregion variables

            //#region methods
            $(`#${dtReceiptsId}`)?.DataTable()?.row(dtReceiptsRowIndex)?.data?.([
                //#region old code
                // apartmentReceiptLocal.receiptNumberApartment,
                // dateTimeFormatGlobalSet(receipt.from, tempusDominus?.format?.date?.dmy, 0, false).result,
                // separatorsNumbersSet(apartmentReceiptLocal.total).result,
                // setBadgeStatusGeneric((apartmentReceiptLocal.balance > neutralValue ? 1 : 0), separatorsNumbersSet(apartmentReceiptLocal.balance).result),
                //#endregion old code
                dtRowObj?.receiptNumberApartment,
                dtRowObj?.from,
                dtRowObj?.total,
                dtRowObj?.status,
                buttonProcessGet({
                    id: apartmentReceiptLocal?.id,
                    description: apartment?.identifier,
                    showDetails: true,
                    labelDetails: labels?.receiptDetail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods

            apartmentBalance = numberSet({
                number: apartmentBalance,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            apartmentBalanceLocal = numberSet({
                number: ((apartmentBalance + apartmentReceiptPaymentBeforeLocal?.amount) - apartmentReceiptPaymentLocal?.amount),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            setApartmentBalance(apartmentBalanceLocal);
            //#endregion update receipts (dtReceipts)

            //#region update apartments (dtApartmets)
            //#region variables
            dtRowObj = {
                floor: apartment?.floor,
                identifier: apartment?.identifier,
                balance: separatorsNumbersSet({
                    number: apartmentBalanceLocal,
                    withDecimals: true,
                    consoleLogErrorShow: true,
                    subMethod: currentMethod,
                })?.result,
            };
            //#endregion variables

            //#region methods
            $(`#${dtApartmentsId}`)?.DataTable()?.row(dtApartmentsRowIndex)?.data?.([
                //#region old code
                // apartment.floor,
                // apartment.identifier,
                // separatorsNumbersSet(apartmentBalanceLocal).result,
                //#endregion old code
                dtRowObj?.floor,
                dtRowObj?.identifier,
                dtRowObj?.balance,
                buttonProcessGet({
                    id: apartment?.id,
                    description: apartment?.identifier,
                    showDetails: true,
                    labelDetails: labels?.viewReceipts?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion methods
            //#endregion update apartments (dtApartmets)

            //#region update building balance
            buildingBalanceLocal = numberSet({
                number: buildingBalance,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            buildingBalanceTotalLocal = numberSet({
                number: ((buildingBalanceLocal + apartmentReceiptPaymentBeforeLocal?.amount) - apartmentReceiptPaymentLocal?.amount),
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            setBuildingBalance(buildingBalanceTotalLocal);

            response = await buildingBalanceSetAsync({
                balance: buildingBalanceTotalLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion update building balance

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (payment)

    //#region methods (others)
    const bankAccountsByBankIdGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'bankAccountsByBankIdGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setPayment({
                ...payment,
                [dbProps?.bankId]: e?.target?.value,
            });

            if (!isUndNullEmp({ data: e?.target?.value, subMethod: currentMethod, })?.result) {
                setBankAccountsByBank(
                    bankAccounts?.filter(({ bankId }) => bankId === e?.target?.value) || []
                );
            } else {
                setBankAccountsByBank([]);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region methods
            response = await dateInControlSetAsync({
                date: new Date(),
                paymentDate: payment?.date,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            setShowBanks(
                !isUndNullEmp({ data: payment?.bankOriginId, subMethod: currentMethod, })?.result
            );

            if (!isUndNullEmp({ data: payment?.bankAccountId, subMethod: currentMethod, })?.result &&
                setProcessType !== 0) {
                setBankAccountsByBank(
                    bankAccounts?.filter(({ id }) => id === payment?.bankAccountId) || []
                );
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formValueSetAsync = async ({
        key = '',
        value = '',
        isShowBanks = false,
        subMethod = '',
    }) => {
        const currentMethod = 'formValueSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let processed = false;
            let paymentMethodLocal = paymentMethodModelGet({});
            //#endregion variables

            //#region methods
            if (isShowBanks) {
                paymentMethodLocal = paymentMethods?.find(({ id }) => id === value) || {};
                if (!isUndNullEmp({ data: paymentMethodLocal?.showBanks, subMethod: currentMethod, })?.result) {
                    if (!paymentMethodLocal?.showBanks) {
                        processed = true;
                    }
                    setShowBanks(paymentMethodLocal?.showBanks);
                } else {
                    setShowBanks(false);
                    processed = true;
                }
            }

            if (!processed) {
                setPayment({ ...payment, [key]: value, });
            } else {
                setPayment({ ...payment, [key]: value, bankOriginId: '', bankId: '', bankAccountId: '', });
                setBankAccountsByBank([]);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSetAsync = async ({
        date = new Date(),
        paymentDate = undefined,
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.date = '';
            //const dateTimeObj?.format = tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = tempusDominus?.format?.date?.DDMMYYYY;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: paymentDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: paymentDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: tempusDominus?.icons,
                buttons: tempusDominus?.buttons,
                tooltips: tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${paymentDateId}`)?.datetimepicker({
                date: moment(dateTimeObj?.date, dateTimeObj?.formatTwo),
                default: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const validateFormDataAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region variables
            const paymentDateLocal = $(`#${controls?.inputs?.date?.id}`)?.val();
            const neutralValueStr = separatorsNumbersSet({
                number: neutralValue,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: payment?.paymentMethodId, subMethod: currentMethod, })?.result) {
                setPaymentMethodError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: paymentDateLocal, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: payment?.date, subMethod: currentMethod, })?.result) {
                setDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: payment?.reference, subMethod: currentMethod, })?.result) {
                setReferenceError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (showBanks) {
                if (isUndNullEmp({ data: payment?.bankOriginId, subMethod: currentMethod, })?.result) {
                    setBankError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                    response.isWarning = true;
                }

                if (isUndNullEmp({ data: payment?.bankId, subMethod: currentMethod, })?.result) {
                    setBankDestinyError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                    response.isWarning = true;
                }

                if (isUndNullEmp({ data: payment?.bankAccountId, subMethod: currentMethod, })?.result) {
                    setBankAccountDestinyError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                    response.isWarning = true;
                }
            }

            if (isUndNullEmp({ data: payment?.amount, subMethod: currentMethod, })?.result) {
                setAmountError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (payment?.amount <= neutralValue || isNaN(payment?.amount)) {
                setAmountError(`${labels?.amount?.[languageObj?.id]}. ${messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setBankError('');
            setDateError('');
            setAmountError('');
            setReferenceError('');
            setBankDestinyError('');
            setPaymentMethodError('');
            setBankAccountDestinyError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const dateTimeObj?.date = $(`#${paymentDateId}`)?.datetimepicker('date')?._d;
            //#endregion old code
            const dateTimeObj = {
                date: $(`#${paymentDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            payment.date = !isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ? dateTimeObj?.date : payment?.date;
            payment.amount = parseFloat(payment?.amount) || neutralValue;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.selects?.paymentMethod?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.selects?.bankOrigin?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.selects?.bankDestiny?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.selects?.bankAccount?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.date?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.inputs?.reference?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.inputs?.amount?.id}`)?.attr({ readOnly: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, [payment?.id]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.payment?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.paymentsLogo}></img> - {processType === 0 ? labels?.registerPayment?.[languageObj?.id] : (processType === 1 ? labels?.edit?.[languageObj?.id] : labels?.paymentDetails?.[languageObj?.id])}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ?
                paymentAddAsync({ e: e, subMethod: 'form - onSubmit', }) :
                (processType === 1 ?
                    paymentEditAsync({ e: e, subMethod: 'form - onSubmit', }) :
                    e.preventDefault())}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processType === 0 ? paymentAddAsync(e) : (processType === 1 ? paymentEditAsync(e) : e.preventDefault())}> */}
                    {/* <div className='card'> */}
                    {/* <div className='card-body'> */}
                    {processType !== 2 ?
                        //#region add / edit
                        <div>
                            {/* {!isUndefined(paymentMethods) && !isUndefined(payment) ? */}
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <select id={controls?.selects?.paymentMethod?.id}
                                        className={controls?.selects?.paymentMethod?.className}
                                        //autoFocus
                                        defaultValue={payment?.paymentMethodId}
                                        disabled={processType === 2}
                                        onChange={(e) => formValueSetAsync({
                                            key: dbProps?.paymentMethodId,
                                            value: e?.target?.value,
                                            isShowBanks: true,
                                            subMethod: 'sel - paymentMethod',
                                        })}
                                        onFocus={() => setPaymentMethodError('')}
                                        placeholder={labels?.paymentMethods?.[languageObj?.id]}
                                        tooltip='tooltip'
                                        title={labels?.paymentMethods?.[languageObj?.id]} >
                                        <option key='nothing' value=''>{labels?.selectPaymentMethod?.[languageObj?.id]}</option>
                                        {paymentMethods?.map(detail => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                    </select>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.fasFa?.cashRegister} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(paymentMethodError)}</div>
                            </div>
                            {/* : */}
                            {/* <></> */}
                            {/* } */}

                            {/* {!isUndefined(banks) && !isUndefined(payment) && showBanks ? */}
                            {showBanks ?
                                <div>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.bankOrigin?.id}
                                                className={controls?.selects?.bankOrigin?.className}
                                                defaultValue={payment?.bankOriginId}
                                                disabled={processType === 2}
                                                onChange={(e) => formValueSetAsync({
                                                    key: dbProps?.bankOriginId,
                                                    value: e?.target?.value,
                                                    isShowBanks: false,
                                                    subMethod: 'sel - bankOrigin',
                                                })}
                                                onFocus={() => setBankError('')}
                                                placeholder={labels?.banks?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={`${labels?.bank?.[languageObj?.id]} (${labels?.origin?.[languageObj?.id]?.toLowerCase()})`} >
                                                <option key='nothing' value=''>{`${labels?.selectBank?.[languageObj?.id]} (${labels?.origin?.[languageObj?.id]?.toLowerCase()})`}</option>
                                                {banks?.map(detail => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.university} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(bankError)}</div>
                                    </div>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.bankDestiny?.id}
                                                className={controls?.selects?.bankDestiny?.className}
                                                defaultValue={payment?.bankId}
                                                disabled={processType === 2}
                                                onChange={(e) => bankAccountsByBankIdGetAsync({ e: e, subMethod: 'sel - bankDesinity' })}
                                                onFocus={() => setBankDestinyError('')}
                                                placeholder={labels?.banks?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={`${labels?.bank?.[languageObj?.id]} (${labels?.destiny?.[languageObj?.id]?.toLowerCase()})`} >
                                                <option key='nothing' value=''>{`${labels?.selectBank?.[languageObj?.id]} (${labels?.destiny?.[languageObj?.id]?.toLowerCase()})`}</option>
                                                {banksDestiny?.map(detail => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.university} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(bankDestinyError)}</div>
                                    </div>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.bankAccount?.id}
                                                className={controls?.selects?.bankAccount?.className}
                                                //defaultValue={payment?.bankAccountId}
                                                value={payment?.bankAccountId || ''}
                                                disabled={processType === 2}
                                                onChange={(e) => formValueSetAsync({
                                                    key: dbProps?.bankAccountId,
                                                    value: e?.target?.value,
                                                    isShowBanks: false,
                                                    subMethod: 'sel - bankAccount',
                                                })}
                                                onFocus={() => setBankAccountDestinyError('')}
                                                placeholder={labels?.bankAccount?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={`${labels?.bankAccount?.[languageObj?.id]} (${labels?.destiny?.[languageObj?.id]?.toLowerCase()})`} >
                                                <option key='nothing' value=''>{`${messages?.selectBankAccount?.[languageObj?.id]}`}</option>
                                                {bankAccountsByBank?.map(detail => (<option key={detail?.id} value={detail?.id}>{detail?.number}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.piggyBank} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(bankAccountDestinyError)}</div>
                                    </div>
                                </div>
                                :
                                <></>
                            }

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        {/* <DatePicker /> */}
                                        <div className='input-group mb-3'>
                                            {/* {!isUndefined(payment) && !isUndefined(payment.date) ? */}
                                            <div id={paymentDateId}
                                                className='input-group date'
                                                data-target-input='nearest'>
                                                <input id={controls?.inputs?.date?.id}
                                                    className={controls?.inputs?.date?.className}
                                                    data-target={`#${paymentDateId}`}
                                                    data-toggle='datetimepicker'
                                                    disabled={processType === 2}
                                                    onFocus={() => setDateError('')}
                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                    tooltip='tooltip'
                                                    title={labels?.date?.[languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append'
                                                    data-target={`#${paymentDateId}`}
                                                    data-toggle='datetimepicker'>
                                                    <div className='input-group-text'>
                                                        <i className={icons?.calendarAlt}></i>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* : */}
                                            {/* <></> */}
                                            {/* } */}
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.reference?.id}
                                                className={controls?.inputs?.reference?.className}
                                                //className='form-control bg-transparent text-black'
                                                disabled={processType === 2}
                                                onChange={(e) => formValueSetAsync({
                                                    key: dbProps?.reference,
                                                    value: e?.target?.value,
                                                    isShowBanks: false,
                                                    subMethod: 'input - reference',
                                                })}
                                                onFocus={() => setReferenceError('')}
                                                placeholder={labels?.reference?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.reference?.[languageObj?.id]}
                                                value={payment?.reference || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(referenceError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.amount?.id}
                                        className={controls?.inputs?.amount?.className}
                                        disabled={processType === 2}
                                        onChange={(e) => formValueSetAsync({
                                            key: dbProps?.amount,
                                            value: validateDecimals({
                                                e: e,
                                                languageId: languageObj?.id,
                                                subMethod: 'input - amount'
                                            }),
                                            isShowBanks: false,
                                        })}
                                        onFocus={() => setAmountError('')}
                                        placeholder={labels?.amount?.[languageObj?.id]}
                                        tooltip='tooltip'
                                        title={labels?.amount?.[languageObj?.id]}
                                        value={payment?.amount || '0.00'} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.moneyBillWave} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(amountError)}</div>
                            </div>
                        </div>
                        //#endregion add / edit
                        :
                        //#region details
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.paymentMethod?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{paymentMethods?.find(({ id }) => id === payment?.paymentMethodId)?.description || ''}</b>
                                </div>
                            </div>

                            {showBanks ?
                                <div>
                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.bank?.[languageObj?.id]} ({labels?.origin?.[languageObj?.id]?.toLowerCase()}):
                                        </div>
                                        <div className='col-md-8'>
                                            <b>{banks?.find(({ id }) => id === payment?.bankOriginId)?.description || ''}</b>
                                        </div>
                                    </div>

                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.bank?.[languageObj?.id]} ({labels?.destiny?.[languageObj?.id]?.toLowerCase()}):
                                        </div>
                                        <div className='col-md-8'>
                                            <b>{banks?.find(({ id }) => id === payment?.bankId)?.description || ''}</b>
                                        </div>
                                    </div>

                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.account?.[languageObj?.id]} ({labels?.destiny?.[languageObj?.id]?.toLowerCase()}):
                                        </div>
                                        <div className='col-md-8'>
                                            <b>{bankAccounts?.find(({ id }) => id === payment?.bankAccountId)?.number || ''}</b>
                                        </div>
                                    </div>
                                </div>
                                :
                                <></>
                            }

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.date?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        dateTimeFormatGlobalSet({
                                            date: payment?.date,
                                            type: languageObj?.format?.date?.f1,
                                            format: 0,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: currentMethod,
                                        })?.result
                                    }</b>
                                </div>
                            </div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.reference?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{payment?.reference || ''}</b>
                                </div>
                            </div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.amount?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: payment?.amount,
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: 'lbl - paymentAmount',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            {/* <hr /> */}

                        </div>
                        //#endregion details
                    }

                    {!isUndNullEmp({ data: payment?.concilationStatus, subMethod: currentMethod, })?.result ?
                        <div>
                            <hr />
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.reconcilied?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <input
                                            checked={payment?.concilationStatus === 'S' || false}
                                            id={chkReconcileId}
                                            readOnly
                                            type='checkbox' />
                                        <label htmlFor={chkReconcileId}></label>
                                    </div>
                                </div>
                            </div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.date?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        dateTimeFormatGlobalSet({
                                            date: payment?.concilationDate,
                                            type: languageObj?.format?.date?.f1,
                                            format: languageObj?.format?.time?.type,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: 'lbl - date',
                                        })?.result
                                    }</b>
                                </div>
                            </div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.remark?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    {
                                        payment?.concilationStatus === 'W' ?
                                            <i className='fas fa-exclamation-triangle text-warning'></i>
                                            :
                                            <></>
                                    } <b>{
                                        HtmlParser(`${payment?.conciliationRemark?.replaceAll('\n', '<br/>')}`)
                                    }</b>
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                    }
                    {/* </div> */}

                    {/* <div className='card-footer'>
                        <div className='form-group text-right'>
                            <button className='btn btn-outline-warning'
                                hidden={processType === 2}
                                tooltip='tooltip'
                                title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                type='submit'>
                                <i className={icons?.save}></i>
                            </button>
                            <button className='btn btn-outline-success mx-1'
                                tooltip='tooltip'
                                title={labels?.close?.[languageObj?.id]}
                                type='reset'
                                onClick={() => defaultValueSetAsync(true)}>
                                <i className={icons?.arrowAltCircleLeft}></i>
                            </button>
                        </div>
                    </div> */}
                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}